<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title" translate>
    lblAssociatedDealers
    <span class="font16 ml-3 text-light float-none" *ngIf="customerNo">
      #{{ customerNo }} {{ customerName ? " - " : "" }} {{ customerName }}
    </span>
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="OnClose()">
    <span aria-hidden="true"> × </span>
  </button>
</div>
<div class="modal-body">
  <div class="maxh-auto">
    <table
      aria-describedby="associatedDealers"
      class="tablest1 border-bottom mt-2"
    >
      <ng-container>
        <thead>
          <tr>
            <th scope="col" translate>lblCustomerNo</th>
            <th scope="col" translate>lblDealer</th>
            <th scope="col" translate>lblPaymentMethod</th>
            <th scope="col" translate>lblPaymentTerms</th>
            <th scope="col" translate>lblReminderTerms</th>
            <th scope="col" translate>lblLaborPriceGroup</th>
            <th scope="col" translate>lblItemSalesPriceGroup</th>
            <th scope="col" translate>lblIsVatApplyOnDemand</th>
            <th scope="col" translate>lblCreatedDate</th>
            <th scope="col" translate>lblUpdatedDate</th>
          </tr>
        </thead>
      </ng-container>

      <tbody>
        <ng-container
          *ngIf="
            customerDealerAssociation?.length > 0 ||
              customerDealerAssociation?.length > 0;
            else load_else
          "
        >
          <ng-container *ngIf="customerDealerAssociation?.length > 0">
            <tr
              *ngFor="
                let association of customerDealerAssociation;
                let i = index
              "
            >
              <td>{{ association.customerNo }}</td>
              <td>{{ association.dealerName }}</td>
              <td>{{ association.paymentMethod }}</td>
              <td>{{ association.paymentTerms }}</td>
              <td>{{ association.reminderTerms }}</td>
              <td>{{ association.laborPriceGroup }}</td>
              <td>{{ association.itemSalesPriceGroup }}</td>
              <td>{{ association.isVatappliedOnDemand }}</td>
              <td>{{ association.createdDate | date : "short" }}</td>
              <td>{{ association.updatedDate | date : "short" }}</td>
            </tr>
          </ng-container>
        </ng-container>
        <ng-template #load_else>
          <tr>
            <td colspan="10" class="no-record" translate>lblNoRecordsFound</td>
          </tr>
        </ng-template>
      </tbody>
    </table>
  </div>
</div>
<div class="modal-footer justify-content-between">
  <div class="ml-auto">
    <button
      type="button"
      class="btn btn-secondary"
      (click)="OnClose()"
      translate
    >
      <em class="far fa-times-circle"></em> lblCancel
    </button>
  </div>
</div>
